import { render, staticRenderFns } from "./CandidateDB.vue?vue&type=template&id=e9f0a1a6&"
import script from "./CandidateDB.vue?vue&type=script&lang=js&"
export * from "./CandidateDB.vue?vue&type=script&lang=js&"
import style0 from "./CandidateDB.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports